import React from 'react';

const Icon = (): JSX.Element => (
  /* eslint-disable */
  <svg
    width="216"
    height="208"
    viewBox="0 0 216 208"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M165.059 135.476C165.059 136.121 164.76 136.776 164.135 137.416C163.508 138.059 162.576 138.66 161.385 139.176C159.005 140.208 155.682 140.858 151.986 140.858C148.289 140.858 144.967 140.208 142.587 139.176C141.396 138.66 140.464 138.059 139.837 137.416C139.212 136.776 138.912 136.121 138.912 135.476C138.912 134.831 139.212 134.176 139.837 133.536C140.464 132.893 141.396 132.292 142.587 131.776C144.967 130.744 148.289 130.094 151.986 130.094C155.682 130.094 159.005 130.744 161.385 131.776C162.576 132.292 163.508 132.893 164.135 133.536C164.76 134.176 165.059 134.831 165.059 135.476Z"
      fill="white"
      stroke="#757575"
    />
    <path
      d="M121.5 137L147.329 122.192L183.246 133.694L157.132 148.282L132 141"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path
      d="M158.604 134.547C155.527 133.67 152.672 134.363 151.844 135.3C151.015 136.237 151.743 137.354 153.475 138.047"
      stroke="#757575"
      stroke-linecap="round"
    />
    <ellipse cx="147" cy="135.954" rx="1" ry="0.5" fill="#757575" />
    <ellipse cx="151" cy="132.954" rx="1" ry="0.5" fill="#757575" />
    <path
      d="M1 34.9335V105.063L62.0803 140.354V70.2244M1 34.9335L62.0803 70.2244M1 34.9335L62.0803 1L123.161 34.9335L62.0803 70.2244"
      stroke="#757575"
    />
    <path
      d="M123.613 34.9336V61.1756M62.0803 140.806L73.5 133.5M101.5 117.5L110.699 111.85M123.613 82.6668V92.3944"
      stroke="#757575"
    />
    <path
      d="M62.3195 85.6074C69.1062 85.6075 78.1551 86.5124 83.132 99.1809C86.7452 108.378 88 112.454 98.9677 116.374C109.653 120.193 104.849 128.59 111.636 134.019C118.423 139.449 124.757 133.567 133.806 142.616C141.045 149.855 142.553 157.094 142.403 159.809L139.235 158.451L137.426 162.523L134.711 161.166L132.901 165.691L130.186 164.333L128.377 168.405L125.21 167.048L122.947 171.572L119.78 169.763L117.97 174.287L114.803 172.477L112.089 177.454C111.787 173.835 109.109 165.718 102.594 160.651C94.4495 154.317 91.7285 158.904 85.3942 154.379C79.06 149.855 80.9171 143.411 78.1551 138.544C74.5355 132.165 66.8261 130.661 62 129.454M62.3195 101.443L73.1782 94.6564"
      stroke="#757575"
    />
    <path d="M104.397 156.189L122.947 144.426" stroke="#757575" />
    <path d="M111.636 162.976L122.042 156.642" stroke="#757575" />
    <path d="M126.115 154.379L132.449 150.76" stroke="#757575" />
    <path
      d="M66.6365 119.66L81.7746 110.492M72.7241 126.484L88.3245 116.874M64.1291 110.492L67.7487 108.23"
      stroke="#757575"
    />
    <path d="M72.2733 105.515L79.06 101.443" stroke="#757575" />
    <path d="M79.5125 131.757L95.3481 121.803" stroke="#757575" />
    <path d="M83.5845 139.901L103.04 128.138" stroke="#757575" />
    <path d="M85.8467 148.045L96.253 141.711" stroke="#757575" />
    <path d="M93.0859 153.475L96.7055 151.212" stroke="#757575" />
    <path d="M99.4201 149.855L114.351 140.354" stroke="#757575" />
    <path
      d="M82.9143 73.8495L116.795 53.1099L135.025 75.9015L106.873 93.0529"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path d="M105.063 78.8207L120.446 69.3193" stroke="#757575" />
    <path d="M110.945 80.6308L122.256 73.3916" stroke="#757575" />
    <path
      d="M116.813 53.1143L117.256 52.8825C117.192 52.7597 117.081 52.6691 116.947 52.6322C116.814 52.5953 116.671 52.6155 116.553 52.6878L116.813 53.1143ZM128.969 76.5053L129.228 76.9318C129.453 76.7944 129.533 76.5066 129.412 76.2735L128.969 76.5053ZM82.8956 73.8645L82.6359 73.438C82.4113 73.5754 82.3309 73.8631 82.452 74.0962L82.8956 73.8645ZM95.5863 98.2915L95.1427 98.5233L95.1427 98.5233L95.5863 98.2915ZM97.1726 101.345L96.729 101.577C96.8348 101.78 97.0658 101.885 97.2891 101.831C97.5124 101.777 97.6706 101.577 97.6725 101.347L97.1726 101.345ZM97.1727 101.339L96.9138 100.912C96.7655 101.002 96.6743 101.163 96.6729 101.336L97.1727 101.339ZM107.744 94.9019L108.003 95.329C108.228 95.1919 108.309 94.9037 108.188 94.6702L107.744 94.9019ZM105.61 90.7954L105.351 90.3689C105.126 90.5063 105.046 90.7941 105.167 91.0272L105.61 90.7954ZM116.369 53.3462L128.525 76.7371L129.412 76.2735L117.256 52.8825L116.369 53.3462ZM83.1554 74.291L117.072 53.5408L116.553 52.6878L82.6359 73.438L83.1554 74.291ZM96.0299 98.0597L83.3393 73.6327L82.452 74.0962L95.1427 98.5233L96.0299 98.0597ZM97.6163 101.113L96.0299 98.0597L95.1427 98.5233L96.729 101.577L97.6163 101.113ZM96.6729 101.336L96.6728 101.342L97.6725 101.347L97.6725 101.341L96.6729 101.336ZM107.485 94.4749L96.9138 100.912L97.4316 101.766L108.003 95.329L107.485 94.4749ZM108.188 94.6702L106.054 90.5636L105.167 91.0272L107.3 95.1337L108.188 94.6702ZM105.87 91.2219L129.228 76.9318L128.709 76.0788L105.351 90.3689L105.87 91.2219Z"
      fill="#757575"
    />
    <path
      d="M100.246 71.6897L99.0307 69.3492L89.8104 74.9933L91.0259 77.334L100.246 71.6897Z"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path
      d="M136.74 123.551L134.014 125.27C131.582 126.753 127.018 127.166 123.128 125.298C115.349 121.561 108.791 111.882 108.53 103.754C108.365 99.725 110.33 96.1911 112.762 94.7079L116.397 92.4406"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path
      d="M120.449 102.83C125.899 104.616 128.965 110.543 129.102 113.96C129.133 114.714 129.045 115.389 128.858 115.971"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path
      d="M127.024 123.07C119.241 119.346 112.687 109.684 112.357 101.498C112.028 93.3125 118.123 89.1054 125.907 92.8302C133.693 96.6232 140.247 106.285 140.574 114.403C140.903 122.588 134.811 126.863 127.024 123.07ZM126.222 101.307C122.556 99.5702 119.686 101.212 119.842 105.101C119.996 108.921 123.042 113.489 126.782 115.222C130.378 117.031 133.245 115.32 133.092 111.5C132.935 107.612 129.891 103.112 126.222 101.307Z"
      fill="white"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path
      d="M119.818 105.093L112.389 101.472M124.535 121.654L125.466 114.589"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path
      d="M158.134 114.67L164.216 75.9111L159.944 72.5515L153.888 111.293L158.134 114.67Z"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path
      d="M156.744 73.8095L160.054 72.5903L153.997 111.332L148.943 113.213L150.728 101.797"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path
      d="M153.866 111.355L148.917 113.208L153.106 116.563L158.034 114.707L153.866 111.355Z"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path
      d="M152.82 101.145L157.584 70.5734L153.316 67.2126L148.555 97.7631L152.82 101.145Z"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path
      d="M150.338 68.3816L153.42 67.2391L148.658 97.7899L143.632 99.6729L145.342 88.7077"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path
      d="M148.546 97.8168L143.618 99.6721L147.79 103.002L152.736 101.172L148.546 97.8168Z"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path
      d="M147.44 87.8769L150.953 65.2391L146.694 61.8557L143.181 84.4935L147.44 87.8769Z"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path
      d="M146.799 61.8906L141.783 63.7706L138.269 86.4087L143.285 84.5287L146.799 61.8906Z"
      stroke="#757575"
      stroke-linejoin="round"
    />
    <path
      d="M143.173 84.5484L138.245 86.4028L142.436 89.7577L147.364 87.9033L143.173 84.5484Z"
      stroke="#757575"
      stroke-linejoin="round"
    />
  </svg>
  /* eslint-disable */
);

export default Icon;
